import React, { useState } from "react";
import {
  FaGraduationCap,
  FaHospital,
  FaMapMarkedAlt,
  FaShoppingCart,
} from "react-icons/fa";
import { useGlobalContext } from "./context/globalContext";

const locationBenefitGroups = [
  {
    id: "connectivity",
    label: "Connectivity",
    icon: FaMapMarkedAlt,
    items: [
      { name: "Eastern Express Highway", value: "5 mins" },
      { name: "Teen Hath Naka", value: "10 mins" },
      { name: "Thane Railway Station", value: "15 mins" },
      { name: "Mulund Check Naka", value: "15 mins" },
      { name: "Ghodbunder Road", value: "20 mins" },
    ],
  },
  {
    id: "education",
    label: "Education",
    icon: FaGraduationCap,
    items: [
      { name: "Smt. Sulochanadevi Singhania School", value: "12 mins" },
      { name: "D.A.V. Public School", value: "10 mins" },
      -{ name: "CP Goenka International School", value: "15 mins" },
      { name: "Billabong High International School", value: "20 mins" },
      { name: "NKTT College", value: "12 mins" },
    ],
  },
  {
    id: "hospitals",
    label: "Hospitals",
    icon: FaHospital,
    items: [
      { name: "Jupiter Hospital", value: "10 mins" },
      { name: "Bethany Hospital", value: "12 mins" },
      { name: "Kaushalya Medical Foundation", value: "15 mins" },
      { name: "Currae Specialty Hospital", value: "18 mins" },
      { name: "Horizon Prime Hospital", value: "18 mins" },
    ],
  },
  {
    id: "lifestyle",
    label: "Malls & Lifestyles",
    icon: FaShoppingCart,
    items: [
      { name: "Viviana Mall", value: "10 mins" },
      { name: "Korum Mall", value: "12 mins" },
      { name: "R Mall", value: "15 mins" },
      { name: "High Street Mall", value: "15 mins" },
      { name: "The Walk, Hiranandani Estate", value: "20 mins" },
    ],
  },
];

const LocationBenefits = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  const [activeBenefit, setActiveBenefit] = useState(null);

  const activeBenefitGroup =
    locationBenefitGroups.find((group) => group.id === activeBenefit) || null;

  return (
    <section
      className="section shadow-sm lazyloaded location-benefits-section"
      id="location-benefits"
    >
      <span className="section-link"></span>
      <h2 className="head text-capitalize text-center">
        {project} - Location Benefits
      </h2>

      <div className="location-benefits__layout">
        <div className="location-benefits__map-shell">
          <iframe
            className="location-benefits__map"
            title="L&T Wagle Estate location map"
            src="https://www.google.com/maps?q=L%26T%20Wagle%20Estate%20Thane&z=14&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <div className="location-benefits__content">
          <div
            className={`location-benefits__interactive ${
              activeBenefitGroup ? "is-open" : ""
            }`}
            onMouseLeave={() => setActiveBenefit(null)}
          >
            <div className="location-benefits__tabs" role="tablist">
              {locationBenefitGroups.map((group, index) => {
                const Icon = group.icon;
                const isActive = activeBenefit === group.id;

                return (
                  <button
                    key={group.id}
                    type="button"
                    className={`location-benefits__tab ${
                      isActive ? "is-active" : ""
                    } ${index === locationBenefitGroups.length - 1 ? "location-benefits__tab--offset" : ""}`}
                    onMouseEnter={() => setActiveBenefit(group.id)}
                    onFocus={() => setActiveBenefit(group.id)}
                    onClick={() => setActiveBenefit(group.id)}
                    aria-pressed={isActive}
                  >
                    <Icon aria-hidden="true" />
                    <span>{group.label}</span>
                  </button>
                );
              })}
            </div>

            {activeBenefitGroup && (
              <div className="location-benefits__card">
                <ul className="location-benefits__list">
                  {activeBenefitGroup.items.map((item) => (
                    <li key={item.name}>
                      <span>{item.name}</span>
                      <strong>{item.value}</strong>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          <button
            type="button"
            className="btn btn-info micro-form-btn effetGradient effectScale enqModal location-benefits__cta"
            onClick={() =>
              handleShowModal(
                activeBenefitGroup
                  ? `Location Benefits - ${activeBenefitGroup.label} Details`
                  : "Location Benefits - Get All Details",
              )
            }
          >
            Get All Details
          </button>
        </div>
      </div>
    </section>
  );
};

export default LocationBenefits;
